function renderProduct(handle) {
    fetch(`/products/${handle}?section_id=biamar-card-product`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const body = html.body.childNodes;
        const card = body[0].querySelector(".grid__item");
        const targetElement = document.querySelector("#product-grid");
        targetElement.appendChild(card);
        product_init_utils();
      })
      .catch((e) => {
        console.error(e);
      });
}

$(document).ready(function() {
    let wishlist = JSON.parse(localStorage.getItem('wishlist')) || [];

    // Itera sobre cada item da lista
    wishlist.forEach(function(productHandle) {
        renderProduct(productHandle);
    });

});
